<template>
  <div>
    <v-col v-if="renderiza" cols="12" class="py-0 grey--text text--darken-4 font-weight-regular">
      <div class="pl-4" style="font-size: 16px">
        <v-row no-gutters>
          <v-col cols="12" class="pb-0">
            <span class="font-weight-bold">Dados do Cliente:</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label-1">Documento Federal</span><br/>
            {{model.Pessoa.DocumentoFederal}}
          </v-col>
          <v-col cols="6">
            <span class="text-label-1">Razão Social</span><br/>
            {{model.Pessoa.Nome}}
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-5">
          <v-col cols="12" class="pb-0">
            <span class="font-weight-bold">Operação de Crédito</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Tipo de Operação: Com Garantia</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Produto: Financiamento de Veículos</span>
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-5">
          <v-col cols="12" class="pb-0">
            <span class="font-weight-bold">Dados do Veículo:</span>
          </v-col>
          <v-col cols="12">
            <span class="text-label">Ano do Veículo: {{ model.PropostaDadosVeiculo.AnoFab}}</span>
          </v-col>
        </v-row>

        <v-row class="mt-5" no-gutters>
          <v-col cols="12">
            <span class="font-weight-bold">Dados da Operação de Crédito:</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Valor do Veículo: {{ $api.UI.Format.Currency(model.VlrProdutoBem) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Valor de Entrada: -{{ $api.UI.Format.Currency(model.VlrEntrada) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Tarifa de Cadastro: {{ $api.UI.Format.Currency(model.selecionado.VlrTAC) }}</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Valor Solicitado: {{ $api.UI.Format.Currency(model.VlrProdutoBem - model.VlrEntrada) }}</span>
          </v-col>
          <v-col cols="12">
            <span class="text-label">IOF: {{ $api.UI.Format.Currency(model.selecionado.VlrIOF) }}</span>
          </v-col>

          <v-col cols="6" class="my-2 font-weight-bold">
            <span class="text-value-label">Valor Total Financiado: </span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.selecionado.VlrTotalCredito)}}</span>
          </v-col>
          <v-col cols="6" class="my-2 font-weight-bold">
            <span class="text-value-label">Prestações: </span>
            <span class="text-value">{{ $api.UI.Format.Date(model.DtPrimeiroVencto)}} até {{ $api.UI.Format.Date($api.UI.Date.AddMonth(model.DtPrimeiroVencto, model.selecionado.Prazo)) }}</span>
          </v-col>

          <v-col cols="6" class="font-weight-bold">
            <span class="text-value-label">Número de Prestações: </span>
            <span class="text-value">{{ model.selecionado.Prazo }}</span>
          </v-col>
          <v-col cols="6">
            <span class="text-value-label">Valor da Prestação: </span>
            <span class="text-value">{{ $api.UI.Format.Currency(model.selecionado.VlrParcela)}}</span>
          </v-col>
          <v-col cols="6">
            <span class="text-value-label">Taxa de Juros: </span>
            <span class="text-value">{{$api.UI.Format.Decimal(model.selecionado.PercJurosMensal)}}% a.m. / {{$api.UI.Format.Decimal(model.selecionado.PercJurosAnual)}}% a.a.</span>
          </v-col>
          <v-col cols="6">
            <span class="text-value-label">CET: </span>
            <span class="text-value">{{ $api.UI.Format.Decimal(model.selecionado.PercCETMensal)}}% a.m.  /  {{ $api.UI.Format.Decimal(model.selecionado.PercCETAnual) }}% a.a.</span>
          </v-col>
          <v-col cols="6">
            <span class="text-value-label">Amortização: Price</span>
          </v-col>
          <v-col cols="6">
            <span class="text-value-label">Modalidade: Pré-Fixado</span>
          </v-col>
          <v-col cols="12" class="mt-5">
            <span class="text-strong">Prestações:</span>
          </v-col>
          <v-col cols="6">
            <span class="text-label-1">1º Prestação</span><br/>
            <span class="text-value">
              Data: {{ $api.UI.Format.Date(model.DtPrimeiroVencto)}}</span>
          </v-col>

          <v-col cols="6">
            <span class="text-label-1">Última Prestação</span> <br/>
            <span class="text-value">
              Data: {{ $api.UI.Format.Date($api.UI.Date.AddMonth(model.DtPrimeiroVencto, model.selecionado.Prazo)) }}
            </span>
          </v-col>

          <v-col cols="6" class="mt-5">
            <span class="text-label-1 font-weight-bold">Valor Total da Dívida</span><br/>
            <span class="text-value">{{ $api.UI.Format.Currency(model.selecionado.VlrTotalDivida)}}</span>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="12" class="pl-4 pb-0 mt-6 d-flex justify-center">
          <span style="font-size: 16px" class="text-weigth-bold">Valor Total da Dívida</span>
        </v-col>
        <v-col cols="12">
          <v-divider class="accent" />
        </v-col>
        <v-col cols="12" class="px-2 pt-0">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center"> Parcela </th>
                  <th class="text-center"> Vencimento  </th>
                  <th class="text-right"> Prestação </th>
                  <th class="text-right">  Saldo Devedor </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in parcelas" :key="index">
                  <template v-if="index < 3 || verTodasParcelas">
                    <td class="text-center">{{ item.numParcela + 1 }}</td>
                    <td class="text-center">{{ item.vencimento }}</td>
                    <td class="text-right">{{ $api.UI.Format.Currency(item.prestacao) }}</td>
                    <td class="text-right">{{ $api.UI.Format.Currency(item.saldoDevedor) }}</td>
                  </template>
                  <td role="button" v-else-if="index === 3" colspan="4"
                      class="text-center text-decoration-underline accent--text" @click="verTodasParcelas = true">
                    ver todas as parcelas
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return {
      verTodasParcelas: false,
      model: {
        Pessoa: {},
        selecionado: {},
        PropostaDadosVeiculo: {}
      },
      renderiza: false
    }
  },
  computed: {
    parcelas () {
      var auxArray = []
      var parcela = {}
      for (var i = 1; i <= this.model.Prazo; i++) {
        parcela = {
          numParcela: i - 1,
          vencimento: this.$api.UI.Format.Date(this.$api.UI.Date.AddMonth(this.model.DtPrimeiroVencto, i - 1)),
          prestacao: this.model.selecionado.VlrParcela,
          saldoDevedor: this.model.selecionado.VlrTotalDivida - (this.model.selecionado.VlrParcela * (i))
        }
        auxArray.push(parcela)
      }
      return auxArray
    }
  },
  mounted () {
    this.$set(this, 'model', this.value)
    if (this.model.CodigoOperacao) { this.renderiza = true }
  }
}
</script>
